import { AxiosInstance } from 'axios';
import { getWithAuth } from '../InitializeService';
import { buildODataQuery, ODataParams } from '@/utils/odataUtil';

export const getApplicantsWithFilters = (params: ODataParams, instance: AxiosInstance) => {
    return getWithAuth(`applicants${buildODataQuery(params)}`, instance);
};
export const getStaffingApplicantsWithFilters = (params: ODataParams, instance: AxiosInstance) => {
    return getWithAuth(`staffing/dashboard/applicants${buildODataQuery(params)}`, instance);
};
export const getDistinctApplicantCities = (filter: string, instance: AxiosInstance) => {
    return getWithAuth(`applicants/cities?$apply=filter(${filter})/groupby((City))&$orderby=City asc`, instance);
};
